import React from 'react';

export default function NotificationIcon({ active = false, hasNotifications = false, size = 34, ...props }) {
  const strokeColor = active ? '#F5D000' : 'rgba(255,255,255,0.55)';
  const clapperColor = active ? 'rgba(245,208,0,0.6)' : 'rgba(255,255,255,0.45)';

  return (
    <svg
      width={size}
      height={size}
      viewBox="3 1 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ position: 'relative' }}
      {...props}
    >
      {/* bell dome */}
      <path
        d="M11 2.5C11 2.5 6.5 4.5 6.5 10V14.5H15.5V10C15.5 4.5 11 2.5 11 2.5Z"
        stroke={strokeColor}
        strokeWidth="1.8"
        strokeLinejoin="round"
        fill="none"
      />
      {/* wide flat tray */}
      <path
        d="M5 14.5H17"
        stroke={strokeColor}
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      {/* clapper */}
      <path
        d="M9 16.5C9 17.6046 9.89543 18.5 11 18.5C12.1046 18.5 13 17.6046 13 16.5"
        stroke={clapperColor}
        strokeWidth="1.8"
        strokeLinecap="round"
        fill="none"
      />
    </svg>
  );
}
